import { render, staticRenderFns } from "./BsCheckbox.vue?vue&type=template&id=9dcbc8d8"
import script from "./BsCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./BsCheckbox.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports